
    import Vue from 'vue';
    import axios from 'axios';
    import { i18n } from '@/main'; '@/main.js';
       export default Vue.extend({
        
          name: 'App',
          
          
          data: function() {
            return {
              test:'',
              show: false,
              submitSuccess:false,
              intakeForm: {} as any,
              questions:{
    
              } as any,
              intakeFormDTO:{
                consentSignature:'',
                consentSignature2:'',
                consentSignature3:'',
                consentFullName:'',
              } as any,
              branchingOptions:[],
              isLoading:false,
              activeBranchingQuestions:[],
              questionCounter:0,
              sliceCounter:0,
              languageLocalizations:[],
              languageSelected:'',
              dropdownSelectedValues:{},
              isFirstLoading:true,
              signatureEmpty:null,
              validationIdConsentFullName:'vidCFN1'
            }
          },
         
          created: function() {
          
           const { orgName, subOrgName } = this.$route.params;

           if(!orgName || !subOrgName){
                return;
           }
           let url = location.href;
           this.show = true;
          
           axios.get(process.env.VUE_APP_OnlineIntakeWebApiUrl + '/api/dynamiconlineintake/form',{params:{companyName:url}})
                 .then(resp => {
                    this.intakeForm = resp.data;

                 if(resp.data.IntakeForm.DirectionRightToLeft !== undefined && resp.data.IntakeForm.DirectionRightToLeft != null){
                  this.setDirection(resp.data.IntakeForm.DirectionRightToLeft);

                 }
                 
                  if(resp.data.Localizations){
                    this.loadLanguageAsync(resp.data.Localizations);
                  
                  }
                    this.show = false;
                     
                      this.intakeForm.QuestionGroup.forEach((qGroup:any) => {
                     
                      qGroup.Questions.forEach((question:any) => {
                          this.questionCounter++;
                          if(question.BranchingOptions.length > 0){
                            let branchingOption = {} as any;
                            branchingOption[question.ID] = [];
                            question.BranchingOptions.forEach((el:any) => {
                                branchingOption[question.ID].push(el);
                             
                              
                            });
    
                            this.branchingOptions.push(branchingOption);
                          }
    
                            
                            if(question.ControlType === 'Dropdown' || question.ControlType === 'MultiCheckbox'){
                            
                            let defaultControlValueSelect:any = question.DefaultControlValue ?  question.DefaultControlValue + '|' + question.ID : null;
    
                            if(question.ControlType === 'MultiCheckbox' && defaultControlValueSelect === null){
                              defaultControlValueSelect = [];
                            }
                            Vue.set(this.questions, question.Caption.trim().replace(/\s/g, '-').replace(':','') + '+' + qGroup.Name + '-' + qGroup.SubTitle + '+' + question.ControlID, defaultControlValueSelect)
                          }
                          else{
                            let defaultControlValue = question.DefaultControlValue ? question.DefaultControlValue : '';
                         
                            Vue.set(this.questions, question.Caption.trim().replace(/\s/g, '-').replace(':','') + '+' + qGroup.Name + '-' + qGroup.SubTitle + '+' + question.ControlID, defaultControlValue)
                          
                          }
    
                         
                          
                         
                         
                      })

                    })
                    this.questionCounter = Math.ceil(this.questionCounter / 2);

                    
                  })

          },
          mounted:function(){
           
          },
          updated:function(){
           
            this.hideBranchingQuestions();
            this.hideGroupSubGroupQuestions();
            this.isFirstLoading=false;
          
          },
          watch:{
            sliceCounter(newVal){
              console.log(newVal);
            },
            '$i18n.locale': function() {

            }
          },
          computed:{
            
          },
          methods:{
            
            onFormSubmit(){
              
              this.setAllSignatureOnSubmits();
              if(this.signatureEmpty && this.intakeForm?.IntakeForm?.ShowConsentFullName){
               
                return;
              }
              const questionsAnwsers = Object.assign({}, this.questions);
             
              for(var q in questionsAnwsers){
             
                if(Array.isArray(questionsAnwsers[q])){

                    let tempQuestionsAnswer = questionsAnwsers[q];
                    questionsAnwsers[q] = '';
                    tempQuestionsAnswer.forEach((question:any) => {
                   
                      if(question.toString().indexOf('|') >= 0){
                        
                        let questionAnswersSplit = question.toString().split('|');
                     
                        questionsAnwsers[q] += questionAnswersSplit[0] + ',';
                        
                      }else{
                        questionsAnwsers[q] = questionsAnwsers[q].toString();
                      }
                     
                    })

                    questionsAnwsers[q] = questionsAnwsers[q].lastIndexOf(',') >= 0 ? questionsAnwsers[q].slice(0, -1) : questionsAnwsers[q];
                
                }
                
                
                  let value = questionsAnwsers[q] ? questionsAnwsers[q].toString() : null;
                
                  if(value && value.indexOf('|') > 0){
                    value = value.split('|')[0];
                   
                    questionsAnwsers[q] = value;
                  }
              }
    
              const languageSelectedCode = this.languageSelected.split('-').length > 0 ? this.languageSelected.split('-')[0] : null;
              const submitOnlineIntakeDTO = {
                intakeFormDTO:this.intakeFormDTO,
                intakeForm:this.intakeForm.IntakeForm,
                localizationSelected:languageSelectedCode,
                questionsAnwsers,
              }
              this.show = true;
            
              axios.post(process.env.VUE_APP_OnlineIntakeWebApiUrl + '/api/dynamiconlineintake/form', submitOnlineIntakeDTO)
                .then(resp => {
    
                  if(resp.data){
                    this.show = false;
                    this.submitSuccess = true;
                  }
                })
              
              
            },
            saveSignature(event:any){
              event.preventDefault();
              const { data } = this.$refs.signaturePad.saveSignature();
               
              if(data){
                this.intakeFormDTO.consentSignature = data;
              }
             
              if(this.$refs.signaturePad2.saveSignature().data){
                this.intakeFormDTO.consentSignature2 = this.$refs.signaturePad2.saveSignature().data;
              }

              if(this.$refs.signaturePad3.saveSignature().data){
                this.intakeFormDTO.consentSignature3 = this.$refs.signaturePad3.saveSignature().data;
              }

    
            },
              clearSignature(signaturePadSection:any){

              if(signaturePadSection === '1'){
                this.$refs.signaturePad.clearSignature();
              }

              if(signaturePadSection === '2'){
                this.$refs.signaturePad2.clearSignature();
              }

              if(signaturePadSection === '3'){
                this.$refs.signaturePad3.clearSignature();
              }
            },
            setAllSignatureOnSubmits(){
            
               if(this.$refs.signaturePad?.saveSignature().data){
                 this.intakeFormDTO.consentSignature = this.$refs.signaturePad.saveSignature().data;
                 this.signatureEmpty = false;
               }else{
                this.signatureEmpty = true;
               
                 return;
               }
 
               if(this.$refs.signaturePad2?.saveSignature().data){
                 this.intakeFormDTO.consentSignature2 = this.$refs.signaturePad2.saveSignature().data;
               }
 
               if(this.$refs.signaturePad3?.saveSignature().data){
                 this.intakeFormDTO.consentSignature3 = this.$refs.signaturePad3.saveSignature().data;
               }
            },
            resetBranchingQuestions(){
              
              this.$refs.questionRefs.forEach((el:any) => {
                let elementID = el.children[1].firstElementChild.id;
                
             
                //for single checkbox question, the element structure is different
                if(el.children[1]?.children[0]?.firstElementChild?.children[0] !== undefined){
                  elementID = el.children[1].children[0].firstElementChild.children[0].id;
                }

                if(elementID.indexOf('_BV_option_0') >= 0){
                      elementID = elementID.replace('_BV_option_0','');
                    }

                //this.setIsRequired(elementID, false);
                // if(el.children[1].firstElementChild.hasAttribute('data-required')){
                //     this.$refs.validationProvider.forEach((v:any) => {
                     
                //        if(v.vid == elementID){
                       
                //          v.disabled = true;
                //        }
                //     })
                //     }
                const [branchingOption] = this.intakeForm.BranchingOptions.filter((x:any) => x.NextQuestionID === elementID);
               
                if(branchingOption)
                {
                  
                  el.style =  'display:none';
                  this.setIsRequired(elementID, false);
                 
                }
              })
             
            },
          
            hideBranchingQuestions(){
              if(!this.isLoading){
                 
                  if(this.$refs.questionRefs){
                   
                    this.$refs.questionRefs.forEach((el:any) =>{ 
                 
                  let elementID = el.children[1].firstElementChild.id;
                    
                    //for single checkbox question, the element structure is different
                if(el.children[1]?.children[0]?.firstElementChild?.children[0] !== undefined){
                  elementID = el.children[1].children[0].firstElementChild.children[0].id;
                }

                 
                   if(elementID){
                      if(elementID.indexOf('_BV_option_0') >= 0){
                        elementID = elementID.replace('_BV_option_0','');
                        
                      }    
                      for (const [ , value] of Object.entries(this.intakeForm.BranchingOptions)) {
                        const branchingOption = value as any;
                          
                          if(branchingOption.NextQuestionID == elementID && !branchingOption.IsHideWhenAnswerCorrect){
                            
                            el.style = 'display:none'
                            if(el.children[1].firstElementChild.hasAttribute('data-required') || el.children[1].firstElementChild.hasAttribute('is-required-temp')){
                       
                              //el.children[1].firstElementChild.removeAttribute('required');
    
                              this.setIsRequired(elementID, false);
                             
                              if(this.isFirstLoading){
                                el.children[1].firstElementChild.setAttribute('is-required-temp', true);
                  
                              }

                             }

                           
                          }
                          
                        }
    
                        
    
                    }
    
                this.isLoading = true;
              })
                  }
                  
              }
            },
            displayBranchingQuestions(questionID:any, dropDownValue:any, originalAnswerBranchingFields:any){
              const branchingOptionFound = this.intakeForm.BranchingOptions.filter((x:any) => x.QuestionID === questionID && x.Answer === dropDownValue || x.Answer === originalAnswerBranchingFields);
             
              if(branchingOptionFound.length > 0){
               
                this.$refs.questionRefs.forEach((el:any) =>{ 
                    let elementID = el.children[1].firstElementChild.id;
                  
                    //for single checkbox question, the element structure is different
                    if(el.children[1]?.children[0]?.firstElementChild?.children[0] !== undefined){
                      elementID = el.children[1].children[0].firstElementChild.children[0].id;
                    }
                    
                    if(elementID.indexOf('_BV_option_0') >= 0){
                      elementID = elementID.replace('_BV_option_0','');
                    }
                    branchingOptionFound.forEach((bo:any) => {
                    
                      if(elementID && bo.NextQuestionID === elementID){
                        
                        el.style = bo.IsHideWhenAnswerCorrect ? 'display:none' : '';
    
                        //this.setIsRequired(elementID, true);
                          
                        if(el.children[1].firstElementChild.hasAttribute('is-required-temp')){
                          var isRequired = el.children[1].firstElementChild.getAttribute('is-required-temp')
                        
                          if(isRequired){
                            this.setIsRequired(elementID, true);
                          }
                        }
    
                        
                    }
                    
                    })
                })
           }

           if(branchingOptionFound.length == 0 ){
            const currentBranchingOptions = this.intakeForm.BranchingOptions.filter((x:any) => x.QuestionID === questionID || x.Answer === originalAnswerBranchingFields);
            
            this.$refs.questionRefs.forEach((el:any) =>{ 
                    let elementID = el.children[1].firstElementChild.id;
                  
                    //for single checkbox question, the element structure is different
                    if(el.children[1]?.children[0]?.firstElementChild?.children[0] !== undefined){
                      elementID = el.children[1].children[0].firstElementChild.children[0].id;
                    }
                    currentBranchingOptions.forEach((bo:any) => {
                       
                      if(elementID && bo.NextQuestionID === elementID && bo.IsHideWhenAnswerCorrect){
                       
                        el.style = '';
                        
                        
                    }
                    
                    })
                })
          }
    
          //const [branchingOptionSelected] = this.intakeForm.BranchingOptions.filter((x:any) => x.NextQuestionID == questionID);
          
    
          // if(branchingOptionSelected){
          //   const branchingOptionsAnswer = this.intakeForm.BranchingOptions.filter((x:any) => x.Answer == branchingOptionSelected.Answer);
          
          //    console.log('branchingOptionsAnswer',branchingOptionsAnswer);
          
          // if(branchingOptionsAnswer.length > 0){
          //   this.$refs.questionRefs.forEach((el:any) =>{ 
          //           const elementID = el.children[1].firstElementChild.id;
                    
          //           branchingOptionsAnswer.forEach((bo:any) => {
          //             if(elementID == bo.NextQuestionID){
                       
          //             el.style = '';
          //             this.setIsRequired(elementID, true);
          //             if(el.children[1].firstElementChild.hasAttribute('data-required')){
          //               el.children[1].firstElementChild.setAttribute('required', true);
          //             }
          //           }
          //           })
                    
          //       })
          //  }
          // }
         
           
            },
            checkIfAnswerIncludedInBranchingOptions(questionId:any){
              const [branchingOption] = this.intakeForm.BranchingOptions.filter((x:any) => x.QuestionID === questionId);
                return branchingOption !== undefined || branchingOption != null;
            },
            getOriginalAnswerforBranchingFields(value:any){
             let localizationKey = '';
             Object.keys(this.intakeForm.Localizations).forEach((l:any) => {
                  if(l !== '$id' &&  l === this.languageSelected){
                    const currentLocalizationData = this.intakeForm.Localizations[this.languageSelected];

                    if(currentLocalizationData){
                      Object.keys(currentLocalizationData).forEach((ld:any) => {
                        if(currentLocalizationData[ld] === value){
                          localizationKey = ld;
                        }
                      })
                    }
                  }
             });

             if(localizationKey !== ''){
              return localizationKey.split('-').pop();
             }
           },
            dropdownChanged(value:any){
              
              const [dropDownValue, questionID] = value.indexOf('|') >= 0 ? value.split('|') : [];
              const OriginalAnswerTriggerBranchingFields = this.getOriginalAnswerforBranchingFields(dropDownValue);
            
              if(this.dropdownSelectedValues[questionID] != ''){
                this.dropdownSelectedValues[questionID] = dropDownValue;
              }
              if(this.checkIfAnswerIncludedInBranchingOptions(questionID)){
                this.resetBranchingQuestions();
                Object.keys(this.dropdownSelectedValues).forEach((ddl:any) => {
                  this.displayBranchingQuestions(ddl, this.dropdownSelectedValues[ddl], OriginalAnswerTriggerBranchingFields);
                  this.hideGroupSubGroupQuestions();
                })
              }
            },
            populateDropdown(question:any){


              let array = [{value:null, text:'Select', disabled:true}]
              
              if(question.ControlType === 'MultiCheckbox'){
                array = [];
              }
              let questionArr = question.ControlValue.split('|').map((val:any, index:any) => ({value: this?.intakeForm?.IntakeForm?.ShowLocalization ? this.$t(question.Caption + '-' + val) + '|' + question.ID + '|' + index: val + '|' + question.ID + '|' + index,text: this?.intakeForm?.IntakeForm?.ShowLocalization ? this.$t(question.Caption + '-' + val) : val}));
              
              questionArr.forEach((el:any) => {
                array.push(el);
              })
              
    
              return array;
            },
            
            getBootstrapSizing(size:any){
              let bootstrapSize = 'sm';
              switch(true){
                case size == 25 :
                  bootstrapSize = 'sm';
                  break;
                case size == 50 :
                  bootstrapSize = 'md';
                  break;
                case size == 100 :
                  bootstrapSize = 'lg';
                  break;
              }
    
              return bootstrapSize;
            },
            setIsRequired(elementID:any, isRequired:any){
             
              this.intakeForm.QuestionGroup.forEach((qGroup:any, qGroupIndex:any) => {
                  const currentQuestion = qGroup.Questions.filter((x:any) => x.ID === elementID);
                  
                  if(currentQuestion.length > 0){
                    
                        Vue.set(this.intakeForm.QuestionGroup[qGroupIndex].Questions.filter((x:any) => x.ID === currentQuestion[0].ID)[0], 'isRequired', isRequired)
                         
                      }
                               
              })
            },
            onLanguageLocalizationsChange(lang:any){
              
                i18n.locale = lang;
                axios.defaults.headers.common['Accept-Language'] = lang;
                //document.querySelector('html').setAttribute('lang', lang);

          
                Object.keys(this.questions).forEach((key:any) => {
                  if(this.questions[key]){
                    const currentQuestion = this.questions[key];
                   
                    if(Array.isArray(currentQuestion)){
                      
                      Vue.set(this.questions, key, []);
                      
                    }else{
                      Vue.set(this.questions, key, '');
                    }
                  }
                })
               
                return lang;
            },
           
            loadLanguageAsync(localizationObject:any){

             
              this.languageLocalizations.push({value:null, text:'Select Language', disabled:true});
               Object.keys(localizationObject).forEach((val) => {
                if(val === '$id') return;
                
                 if(this.languageLocalizations.indexOf(val) < 0){
                 
                    this.languageLocalizations.push(val);
                 }

                i18n.setLocaleMessage(val, localizationObject[val]);
               })
              
            },
            setDirection(isRightToLeft:any){
             
              if(isRightToLeft){
                document.documentElement.setAttribute('dir', 'rtl')
              }else{
                document.documentElement.setAttribute('dir', '')
              }
            },
            hideGroupSubGroupQuestions(){
              
          
             
              let counter = 0;
              let groupHeader = '';
              this.$refs.questionRefs.forEach((el:any) =>{ 
                
                const cssText = el.style.cssText;
                const elementID = el.children[1].firstElementChild.id;
                const [branchingOption] = this.intakeForm.BranchingOptions.filter((x:any) => x.NextQuestionID == elementID);
                const branchingOptionString = JSON.stringify(branchingOption);
                if(groupHeader != el.parentElement.parentElement.parentElement){
                  groupHeader = el.parentElement.parentElement.parentElement;
                  counter = 0;
                }
                if(branchingOptionString && cssText == 'display: none;'){
                  counter++;
                  console.log('hideGroupSubGroupQuestions',counter, branchingOption.TotalQuestionsInGroup)
                  if(counter == branchingOption.TotalQuestionsInGroup){
                    
                    let parentGroup = el.parentElement.parentElement.parentElement;
                    parentGroup.style='display:none';
                    
                    counter = 0;
                  }
                }else{
                  let parentGroup = el.parentElement.parentElement.parentElement;
                  parentGroup.style='';
                }
              })
            } 
    
          }
          
          
        })
        
        